import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  Stack,
} from '@chakra-ui/react';
import * as React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import { PollFormValues } from '@/components/PostingExperience/components/PostingModal/components/CreatePollModal/CreatePollModal';
import { XIcon } from '@/imports/ui/chakra/feather';

export const PollOptions: React.FC = () => {
  const {
    formState: { errors },
    control,
    register,
    trigger,
  } = useFormContext<PollFormValues>();

  const { fields, append, remove } = useFieldArray({
    name: 'options',
    control,
    rules: {
      validate: (options) => {
        return options.filter((option) => !!option.label.length).length > 1
          ? true
          : 'You must create at least two poll options.';
      },
    },
  });

  return (
    <FormControl isInvalid={!!errors.options?.root?.message}>
      <FormLabel>Poll Responses</FormLabel>
      <Stack>
        {fields.map((field, index) => (
          <InputGroup key={field.id}>
            <Input
              placeholder="Add a poll response"
              {...register(`options.${index}.label`, {
                onChange: () => {
                  // Errors weren't being cleared after form updates
                  !!errors.options?.root && trigger('options');

                  // Append a new field automatically when typing in the last poll option field
                  if (index === fields.length - 1) {
                    append({ label: '' }, { shouldFocus: false });
                  }
                },
              })}
            />
            {fields.length > 3 && index !== fields.length - 1 && (
              <InputRightElement>
                <IconButton
                  size="xs"
                  variant="ghost"
                  colorScheme="gray"
                  icon={<XIcon />}
                  aria-label="Remove Option"
                  onClick={() => remove(index)}
                />
              </InputRightElement>
            )}
          </InputGroup>
        ))}
      </Stack>
      <FormErrorMessage>{errors.options?.root?.message}</FormErrorMessage>
    </FormControl>
  );
};
